<template>
<div>
  <v-container>
    <v-row>
      <v-col cols="12" style="min-width: 0;">
        <v-container>
          <v-row>
            <external-series-table v-model="changes" @input="emitChanges($event)" :series="series" :dates="dates" :start="start" :length="length" :title="$t('components.MediaPlanTable.title')" :series-header="$t('components.MediaPlanTable.mediaChannels') + ' (' + spendUnitName + ')'" :show-min-max="false" :show-units="false" :global-unit="spendUnitName" :show-chart="false" :model-frequency="modelFrequency" :pretty-names="prettyNames"></external-series-table>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import ExternalSeriesTable from '@/components/ExternalSeriesTable.vue'

export default {
  data: function () {
    return {
      changes: {},
      mediaPlan: {}
    }
  },
  components: {
    ExternalSeriesTable
  },
  computed: {
    series: function () {
      return Object.keys(this.media).map(medium => {
        return [medium, { default_values: new Array(this.dates.length).fill(0), min: 0, max: 9999999999, unit: this.spendUnitName }]
      }).sort((a, b) => a[0].localeCompare(b[0]))
    },
    sortedMedia: function () {
      return Object.keys(this.media).sort()
    },
    selectedDates: function () {
      return this.dates.slice(this.start, this.start + this.length)
    }
  },
  methods: {
    emitChanges: function (data) {
      let plan = {}
      for (let index = 0; index < this.selectedDates.length; index++) {
        const date = this.selectedDates[index]
        plan[date] = {}
        this.sortedMedia.forEach(medium => {
          plan[date][medium] = data[medium][index]
        })
      }
      this.mediaPlan = plan
      this.$emit('input', this.mediaPlan)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue, oldValue) {
        if (this.value && this.value !== this.mediaPlan) {
          this.mediaPlan = this.value
          // Extract keys and sort them alphabetically
          const keys = Object.keys(this.value).sort()
          // Initialize a new object to store the result
          const result = {}
          // Iterate through each key
          keys.forEach(key => {
            // Iterate through each property of the inner object
            for (const prop in this.value[key]) {
              // If the property doesn't exist in the result, create an array
              if (!result[prop]) {
                result[prop] = []
              }
              // Push the value into the corresponding array in the result
              result[prop].push(this.value[key][prop])
            }
          })
          this.changes = result
        }
      }
    }
  },
  props: {
    value: {
      type: Object
    },
    media: {
      type: Object,
      required: true
    },
    dates: {
      type: Array,
      required: true
    },
    start: {
      type: Number,
      required: true
    },
    length: {
      type: Number,
      required: true
    },
    modelFrequency: {
      type: String,
      required: false,
      default: function () {
        return 'month'
      }
    },
    prettyNames: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    spendUnitName: {
      type: String,
      required: false,
      default () {
        return 'USD'
      }
    }
  }
}
</script>
